import React, { useContext } from 'react'
import propTypes from 'prop-types'
import map from 'lodash/map'
import Box from '@material-ui/core/Box'

import { ActionablesContext } from '../../../../contexts/ActionablesContext'
import { CardHeading, CardContent, CardFooter } from '../../../../components/layout/Card'
import { CueCard, CueCardItem } from '../../../../components/CueCard'
import { Button } from '../../../../components/Button'
import { FnaContext } from '../../context'

export const AssessmentCard = ({ heading, items, emptyStateMessage, onCreate, onShow }) => {
  const {
    state: { onCreateNewScenario },
  } = useContext(FnaContext)
  const { fnaReadOnly, frozen } = useContext(ActionablesContext)
  return (
    <CueCard>
      <CardHeading>
        <h5>{heading}</h5>
      </CardHeading>
      <CardContent>
        <AssessmentItems items={items} />
        {!items &&
          <Box
            display='flex'
            flexDirection='column'
            justifyItems='center'
            alignItems='center'
            mx='4rem'
          >
            <p>
              {emptyStateMessage}
            </p>
            { !fnaReadOnly &&
              <Button
                trackAs={`${heading}: New assessment`}
                primary
                fullWidth
                onClick={onCreate}
              >
                Complete assessment now
              </Button>
            }
            { fnaReadOnly && !frozen &&
              <Button
                trackAs={`${heading}: Create new scenario`}
                primary
                fullWidth
                onClick={() => onCreateNewScenario()}
              >
                Complete in scenario planning
              </Button>
            }
          </Box>
        }
      </CardContent>
      { items &&
        <CardFooter>
          <Button
            trackAs={`${heading}: View assessment`}
            textLink
            onClick={onShow}
          >
            View assessment
          </Button>
        </CardFooter>
      }
    </CueCard>
  )
}

const AssessmentItems = ({ items }) => {
  if (!items)
    return null

  return (
    map(items, (value, name) =>
      <CueCardItem key={name} name={name} value={value} />
    )
  )
}

AssessmentCard.propTypes = {
  heading: propTypes.string.isRequired,
  /** items is used to either provide an object of key-value pairs to be
    * rendered in a card, or `false` to specify not to render anything */
  items: propTypes.oneOfType([
    propTypes.object,
    propTypes.bool
  ]).isRequired,
  emptyStateMessage: propTypes.string.isRequired,
  onCreate: propTypes.func.isRequired,
  onShow: propTypes.func.isRequired,
}
